import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({})
export class StreamCommissionResult extends Mappable {
  id!: string
  title!: string

  static create<Data>(attrs: Data) {
    return new StreamCommissionResult().map(attrs)
  }
}
